import CryptoJS from 'crypto-js'

export default {
    // 加密
    encrypt(word) {
        var key = CryptoJS.enc.Utf8.parse("b58bb6e24da62b01");
        var srcs = CryptoJS.enc.Utf8.parse(word);
        var encrypted = CryptoJS.AES.encrypt(srcs, key, {mode:CryptoJS.mode.ECB,padding: CryptoJS.pad.Pkcs7});
        return encrypted.toString();
    },
    // 解密
    decrypt(word) {
        // keyStr = 'abcdsxyzhkj12345'
        var key = CryptoJS.enc.Utf8.parse("b58bb6e24da62b01");
        var decrypt = CryptoJS.AES.decrypt(word, key, { mode: CryptoJS.mode.ECB, padding: CryptoJS.pad.Pkcs7 })
        return CryptoJS.enc.Utf8.stringify(decrypt).toString();
    },

    /**
     * 解密
     * @param word
     * @returns {*}
    decrypt(word){
        var key = CryptoJS.enc.Utf8.parse("abcdefgabcdefg12");
        var decrypt = CryptoJS.AES.decrypt(word, key, {mode:CryptoJS.mode.ECB,padding: CryptoJS.pad.Pkcs7});
        return CryptoJS.enc.Utf8.stringify(decrypt).toString();
    }*/
}